import { useEffect } from 'react';
import { listProjects } from '../data/projects';
import { loginPath } from './authSession';
import { useI18n } from './i18n';
export function DefaultProjectRedirect({ suffix = '' }: { suffix?: string }) {
  const { t } = useI18n();
  useEffect(() => { void listProjects().then((projects) => window.location.replace(projects[0] ? `/projects/${projects[0].slug}${suffix}` : '/projects/new/setup')).catch(() => window.location.replace(loginPath(location.pathname))); }, [suffix]);
  return <main style={{ padding: 24 }}><p>{t('trips.opening')}</p></main>;
}
